import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../services/guards';

const appRoutes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('../modules/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard]
  },
  {
    path: '',
    loadChildren: () => import('../modules/login.module').then(m => m.LoginModule)
  }
];

export const appRouting: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes);
